export default [
  {
    'label': 'mon',
    'value': '1'
  },
  {
    'label': 'tue',
    'value': '2'
  },
  {
    'label': 'wed',
    'value': '3'
  },
  {
    'label': 'thu',
    'value': '4'
  },
  {
    'label': 'fri',
    'value': '5'
  },
  {
    'label': 'sat',
    'value': '6'
  },
  {
    'label': 'sun',
    'value': '7'
  }
]



// WEBPACK FOOTER //
// ./src/components/access/days.js